export function submittedVideoUrl(id: string) {
  return '/videos?' + new URLSearchParams({ submitted: id });
}

export function showSubmittedVideo(id: string) {
  window.location.assign(submittedVideoUrl(id));
}
